var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB3WarmnessRelativeTemperature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 58a4.999 4.999 0 11-7-4.58V35h4v18.42A5 5 0 0131 58zm4-9.38a13 13 0 11-18 0V7h18v41.62zm-.4 6.66a8.94 8.94 0 00-3-4.3l-.6-.52V29h-7v-4h7v-4h-7v-4h7v-6H21v39.46l-.73.6A9.08 9.08 0 0017.89 62a8.55 8.55 0 005 4.47A9 9 0 0034.6 55.28zM56 10h-3v8h3v-8zm-15.24 8.8l6.93 4 1.5-2.6-6.93-4-1.5 2.6zm0 12.4l1.5 2.6 6.93-4-1.5-2.6-6.93 4zM53 40h3v-8h-3v8zm6.81-10.2l6.93 4 1.5-2.6-6.93-4-1.5 2.6zm8.43-11l-1.5-2.6-6.93 4 1.5 2.6 6.93-4zM54.5 21a4 4 0 100 8 4 4 0 000-8z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B3_Warmness_relative_temperature.947694c8.svg";
export { SvgB3WarmnessRelativeTemperature as ReactComponent };